"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSoftLogic = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class DataSoftLogic {
    constructor() { }
    /**********************************************************************************************************************
     *                     START : DATASOFTLOGIC Software Parser
     * ********************************************************************************************************************/
    /**
     * @function DataSoftLogicSoftwareParser
     * @param pastedData
     * @param event
     * @param callbackEmit
     * @summary DataSoftLogicSoftwareParser Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        try {
            //**Session 1 Patient name*/
            const sessionFirst = (0, helper_1.substrInBetween)(pastedData, "Name:", "Allergies:");
            //**Patient Information*/
            const patientInfo = this.gettingPatientDetails(sessionFirst);
            //**Session 3 Insurance*/
            const sessionThird = (0, helper_1.substrInBetween)(pastedData, "PHARMACY INFORMATION", "ADMITTING DIAGNOSIS");
            const insurance = this.getInsurance(sessionThird);
            //**Session 6 Emergency Contact*/
            const sessionSix = (0, helper_1.substrInBetween)(pastedData, "N/A", "N/A");
            //**Session 7 Primary Physician*/
            const sessionSeven = (0, helper_1.substrInBetween)(pastedData, "Primary Physician:", "CLINICIANS");
            //**Session 8 Pharmacy*/
            const sessionEight = (0, helper_1.substrInBetween)(pastedData, "PHARMACY INFORMATION", "ADMITTING DIAGNOSIS");
            const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
            //**Session 9 Comments*/
            const sessionNine = (0, helper_1.substrInBetween)(pastedData, "N/A", "N/A");
            const comment = this.getComment(sessionNine);
            const sendCallBackData = Object.assign(Object.assign(Object.assign(Object.assign({}, patientInfo), physicianInfo), insurance), comment);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @summary Getting Patient name, number, email, dob, address from DataSoftLogic
     */
    gettingPatientDetails(sessionFirst) {
        if (!sessionFirst) {
            return {};
        }
        let dob = (0, helper_1.substrInBetween)(sessionFirst, "Date of Birth:", "Age:");
        if (dob) {
            dob = (0, helper_1.trim)(dob);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst.substr(0, sessionFirst.indexOf("Status:")))), this.patientPhoneNumberWithAddress(sessionFirst)), { email: (0, helper_1.getEmailAddress)((0, helper_1.substrInBetween)(sessionFirst, "N/A", "N/A")), dob: (0, helper_1.getDOB)(dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from DataSoftLogic
     */
    getInsurance(sessionThird) {
        sessionThird = (0, helper_1.trim)(sessionThird);
        if (!sessionThird) {
            return {};
        }
        let insurance = "";
        const insuranceToBreak = sessionThird.split("\n");
        for (let fIndex = insuranceToBreak.length - 1; fIndex > 0; fIndex--) {
            const preIndexValue = (0, helper_1.trim)(insuranceToBreak[fIndex - 1]);
            const currentValue = (0, helper_1.trim)(insuranceToBreak[fIndex]);
            if (preIndexValue == "Primary:" && currentValue) {
                insurance = currentValue;
                //Loop Break
                break;
            }
        }
        //Primary Insurance and Secondary Insurance
        return { insurance };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from DataSoftLogic
     */
    getPrimaryPhysician(sessionSix, sessionSeven, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 2,
                    },
                ],
                pharmacy: [this.getPharmacy(sessionEight)],
                careGiver: this.getCaregiver(sessionSix),
            },
        };
        const breakPhysician = sessionSeven.split("Admitting Physician:");
        for (const value of breakPhysician) {
            const phyInfo = this.getPhysicianInfo(value);
            if (!primaryPhy.info.physician[0].name) {
                Object.assign(primaryPhy.info.physician[0], phyInfo);
            }
            else {
                Object.assign(primaryPhy.info.physician[1], phyInfo);
                break;
            }
        }
        //@Return
        return primaryPhy;
    }
    getPhysicianInfo(data) {
        try {
            const phyFullName = data.substr(0, data.indexOf("Address:"));
            const breakName = phyFullName.split(" ");
            let fullName = breakName.join(" ").replace(",", "");
            let firstNumber = "";
            if (breakName.length >= 3) {
                fullName = `${(0, helper_1.trim)(breakName[1])} ${(0, helper_1.trim)(breakName[2])} ${(0, helper_1.trim)(breakName[0]).replace(",", "")}`;
            }
            else if (breakName.length >= 2) {
                fullName = `${(0, helper_1.trim)(breakName[1])} ${(0, helper_1.trim)(breakName[0].replace(",", ""))}`;
            }
            const numbers = (0, helper_1.phoneNumbers)(data);
            if (fullName && numbers) {
                firstNumber = numbers[0].replace(/[\s-()]/g, "");
            }
            //Return data
            return {
                name: (0, helper_1.trim)(fullName),
                phoneNo: (0, helper_1.changeNumberUSFormat)(firstNumber),
            };
        }
        catch (error) {
            return {};
        }
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //Blank data Return
        data = (0, helper_1.trim)(data);
        //Return black data
        if (!data) {
            return pharmacyData;
        }
        //convert to array
        const breakData = data.split("Primary:");
        //Remove Last index
        breakData.pop();
        data = breakData.join("");
        //@Return
        return pharmacyData;
    }
    getCaregiver(data) {
        const caregiverData = [
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            },
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 2,
            },
        ];
        //@Return
        return caregiverData;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
            },
        };
        //Numbers
        const numbers = (0, helper_1.phoneNumbers)((0, helper_1.substrInBetween)(firstSession, "Phone:", "Date of Birth:"));
        //Set Last number
        if (numbers && (0, helper_1.arrayLength)(numbers)) {
            const number = (0, helper_1.trim)(numbers[0].replace(/[\s-()]/g, ""));
            info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        }
        //set address
        const addressString = (0, helper_1.substrInBetween)(firstSession, "Address:", "Ethnicity:");
        const breakAddress = addressString.split("\n");
        let fullAddress = addressString.substr(0, addressString.indexOf("Acuity:"));
        const lastAddress = breakAddress[breakAddress.length - 1];
        if ((0, helper_1.arrayLength)(lastAddress) > 5 &&
            lastAddress.match(/^(?=(.*[a-z]){3,})(?=(.*[0-9]){3,})/)) {
            fullAddress += ` ${(0, helper_1.trim)(lastAddress)}`;
        }
        //Set Address
        info.address.placeName = (0, helper_1.trim)(fullAddress);
        //@Return address or phoneNo
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        //Value trim
        if (sessionFirst) {
            sessionFirst = (0, helper_1.trim)(sessionFirst);
        }
        const breakName = sessionFirst.split(",");
        const firstName = breakName.pop();
        name.firstName = firstName ? (0, helper_1.trim)(firstName) : "";
        name.lastName = `${(0, helper_1.trim)(breakName.join(" "))}`;
        //@Return name
        return name;
    }
    /**
     * @function getComment
     * @param comment
     * @summary Getting Comment filed from DataSoftLogic
     */
    getComment(comment) {
        if (comment) {
            return { about: comment };
        }
        return { about: "" };
    }
}
exports.DataSoftLogic = DataSoftLogic;
